
export abstract class PowerBase {

    public key: string;
    public user: string;
    public admin: string;

    public _id: string;
    private _name: string;
    public displayName: string;
    public environment: string;
    public backgroundColor: string = "transparent";

    constructor(init?: any) {
    }

    public get name() {
        return this._name;
    }

    protected set name(value: string) {
        this._name = value;
    }

    public get icon() {
        return null;
    }

    public get type() {
        return null;
    }

    public get sharingType() {
        return null;
    }

}